import { isNumeric } from "../../../utilities/strings";


/**
 * validate
 * @param {*} setErrors 
 * @param {*} state 
 * @returns 
 */
const validate = (setErrors, state) => {
  const { base, baseCount, mold, flavorPct,treatPct, apiList } = state;

  let newErrors = {};
  let validated = true;

  
  //handle base
  if (base === null) {
    newErrors.base = "Please select a base";
    validated = false;
  }
  
  //handle baseCount
  if (!isNumeric(baseCount) || baseCount<=0) {
    newErrors.baseCount = "Please supply a valid suppository count";
    validated = false;
  }

  //handle mold
  if (!isNumeric(mold) || mold<=0) {
    newErrors.mold = "Please supply a valid mold size";
    validated = false;
  }

  
  //handle flavorPct
  if (!isNumeric(flavorPct) || flavorPct < 0 || flavorPct >= 100) {
    newErrors.flavorPct = "Please supply a valid flavor percentage";
    validated = false;
  }

  
  //handle treatPct
  if (!isNumeric(treatPct) || treatPct< 0 || treatPct >= 100) {
    newErrors.treatPct = "Please supply a valid treat percentage";
    validated = false;
  }

  //handle apiList errors
  let apiErrors = [];
  apiList.forEach((item, i) => {
    const { quantity } = item;
    let apiError = {};
    if (!isNumeric(quantity)) {
      apiError.quantity = "Please supply a valid quantity";
      validated = false;
    }
    apiErrors.push(apiError);
  });
  newErrors.apiList = apiErrors;

  //set and return
  setErrors(newErrors);
  return validated;
};

export default validate;
